module.exports = "/fonts/vendor/@fontsource/roboto/files/roboto-greek-ext-400-normal.woff2?169619821ea93019d1bba0c39cdfe80b";